<template>
  <div
    class="absolute min-h-screen w-full flex justify-center items-center"
    style="background: rgba(0, 0, 0, 0.3); z-index: 100"
  >
    <div
      class="w-1/2 p-4 bg-white rounded-md shadow-md"
      style="max-height: 90%"
    >
      <div class="w-full flex justify-between mb-2">
        <div class="w-full font-semibold">Foto Presensi</div>
        <div class="w-2">
          <i class="fa fa-close cursor-pointer" @click="closeModal"></i>
        </div>
      </div>
      <hr />
      <div class="w-full mt-4 p-6">
        <div>
          <img
            :src="presence.photo_url"
            alt="Gambar"
            style="max-width: 100%; margin: auto"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { useStore } from "vuex";

const store = useStore();
// eslint-disable-next-line no-unused-vars
const presence = computed(() => store.state.presence.selectedPresence);

// eslint-disable-next-line no-unused-vars
const closeModal = () => store.dispatch("modal/setModalPresenceImage", false);
</script>
